import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { MonitoringStatus } from 'enum'
import { LearningPathEnrollStatus } from 'enum/learningPathEnrollStatus.enum'
import styles from './ProgressBar.module.scss'

interface ProgressBarProps {
  advance: MonitoringStatus | LearningPathEnrollStatus | undefined
  /**
   * Percentage of the progress
   */
  progressPercentage: number
  counters?: {
    completed: number
    total: number
  }
  styleSize?: 'small' | 'medium'
}

const STATES = {
  [MonitoringStatus.InProgress]: {
    color: '#FFC400',
    label: 'inProgress',
  },
  [MonitoringStatus.Finish]: {
    color: '#36B37E',
    label: 'finished',
  },
  [MonitoringStatus.Pending]: {
    color: '#EC5B56',
    label: 'pending',
  },
}

export const ProgressBar = ({
  advance = MonitoringStatus.Pending,
  progressPercentage,
  counters,
  styleSize,
}: ProgressBarProps) => {
  const percentage = +progressPercentage
  const STATE = (advance && STATES[advance]) || STATES[MonitoringStatus.Pending]
  const { label, color } = STATE

  const { t } = useTranslation()

  return (
    <div
      className={classNames(styles.container, styleSize && styles[styleSize])}
    >
      {counters && (
        <div className={styles.counter}>
          {t('learningPaths.cards.progress.amountOfCourses', {
            completed: counters.completed,
            total: counters.total,
          })}
        </div>
      )}
      <div className={styles.backgroundProgressBar}>
        <div
          className={styles.fillerProgressBar}
          style={{
            width: `${percentage}%`,
            minWidth: '10px',
            backgroundColor: color || '',
          }}
        />
      </div>
      <div className={styles.state}>
        <span> {t(`learningPaths.cards.progress.${label}`)}</span>
        <span>{percentage}%</span>
      </div>
    </div>
  )
}
